export enum SchemeTokenType {
  None = 'NONE',
  Par_Or_Network = 'PAR_AND_NETWORK',
}
